__turbopack_context__.v({
  "input": "Textarea-module__XIweXG__input",
});
